import { useAppSelector } from "store/hooks";
import style from "./TableBody.module.scss";
import { RiLoader5Fill } from "react-icons/ri";
import { useGetAllUsersQuery } from "@RTKQuery/admin/customers/customers";
import { IUser } from "@interfaces/admin/user";

export function TableBody({
    children
}: {
    children: (data: IUser) => JSX.Element
}) {
    const { activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeFilter } = useAppSelector(state => state.customersAdminPage);

    const { data, isFetching } = useGetAllUsersQuery({
        limit: activePaginationLimit,
        page: activePaginationPage,
        search: activeSearchIdParameter,
        is_active: activeFilter
    });

    return (
        <div className={style.body}>
            {
                isFetching
                    ? <div className={style.empty}><RiLoader5Fill className="animate-spin w-[30px] h-[30px]" /></div>
                    : data?.users.map(row => children(row))
            }
        </div>
    )
}

